<!-- @format -->

<div
	*ngIf="review"
	class="hmf-body-m hmf-mb-xs">
	<div
		[highlightKeyword]="newReviewsEnhancement ? highlightedWord : ''"
		[attr.id]="'reviewText_' + review.Id"
		class="line-clamp"
		[ngClass]="(chainAbbr === 'gg')? 'review-text-larger-font': 'review-text'"
		>
		{{ review.ReviewText }}
	</div>
	<hmf-button
		[attr.id]="'viewMoreButton_' + review.Id"
		classList="review-action-button hmf-text-decoration-underline hmf-p-0 hmf-body-m"
		variant="secondary"
		text="View More"
		[attr.aria-label]="'View More for ' + review.Title"
		(keydown)="onKeydownEvent($event)"
		(click)="toggleExpandedReview()"
		tabindex="0"></hmf-button>
</div>
